import React, { useState } from "react";
import Button from "antd/lib/button";
import Input from "antd/lib/input";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import {
  callNotification,
  clearHighChartopData,
} from "../../../../../redux/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  setChangeWidgetOrder,
  setDeleteTopic,
  setDeleteWidget,
  setWidgitTitle,
} from "../../../../../redux/actions/section/section";
import EditIcon from "../../../../../assets/Template/Edit_icon.svg";
import isEqual from "react-fast-compare";
import { setOptionHighChart } from "../../../../../redux/actions/HighChart";
import DeleteWidget from "../DeleteWidget";
import WidgetDescription from "./WidgetDescription";

const WidgetHeaderEditMode = ({
  section_index,
  widget_index,
  widget_name,
  widget_id,
  section_id,
  widgetData,
  modalText,
  isDeleteModalShow,
  setDeleteModalShow,
  openPopoverWidgetDesc,
  setOpenPopoverWidgetDesc,
  sections,
  disableReodering,
}) => {
  const dispatch = useDispatch();
  const [openPopover, setOpenPopover] = useState(false);

  const [popoverStatue, setPopoverStatue] = useState({
    status: null,
    title: null,
  });
  const footerValue = useSelector((state) => state.Section.footerValue);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const Section = useSelector((state) => state.Section.addSection);
  const [updateTitle, setupdateTitle] = useState(null);
  const [checkboxInput, setcheckboxInput] = useState(null);

  const handleClose = (e) => {
    setOpenPopover(false);
    setupdateTitle(widget_name);
    if (e === "save") {
      setPopoverStatue({
        status: e,
        title: updateTitle,
      });
      const setTitleInSection = () => {
        dispatch(
          setWidgitTitle(updateTitle, Section, section_index, widget_index)
        );
      };
      updateTitle !== null && setTitleInSection();
    } else if (e === "cancel") {
      setPopoverStatue({
        status: e,
        title: null,
      });
    }
  };
  const handleOpenChange = () => {
    setOpenPopover(true);
    setupdateTitle(widget_name);
  };

  const graphTitle = (el, id) => {
    setupdateTitle(el);
    if (el.length === 0) {
      callNotification("Widget title can not be empty", "error");
    }
  };
  const checkboxEditMode = (e, index) => {
    if (e === "show") {
      setcheckboxInput({ order: index + 1, widget_index: index });
    } else {
      if (e.target.value <= Section[section_index]?.data?.length) {
        setcheckboxInput({ order: e.target.value, widget_index: index });
      }
    }
  };

  const handleArrayOrder = (fromIndex) => {
    let section = [...Section];
    let arr = Section[section_index]?.data;
    let toIndex = checkboxInput?.order - 1;

    let element = arr[fromIndex];

    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    arr = arr.map((el, i) => {
      el.order = i + 1;
      return el;
    });

    section[section_index].data = arr;

    dispatch(setChangeWidgetOrder(section));
    // dispatch(setOptionHighChart(null));
    setcheckboxInput(null);
  };
  const handleChange = (value, widgetDelete) => {
    if (widgetDelete === "yes") {
      let sectionData = Section?.find((section) => section.id === section_id);
      let sectionIndex = Section?.findIndex(
        (section) => section.id === section_id
      );
      let widgetObject = {
        widget_id: widget_id,
        section_id: section_id,
      };
      let isParentOfExplodedWidget = null;
      if (
        widgetData?.chart?.chart_settings?.duplicate_for_brands &&
        widgetData?.parentId
      ) {
        let global_brands = footerValue?.template
          ? templateDetails?.templateBrands?.columns?.length > 0
            ? templateDetails?.templateBrands?.columns?.[0]
            : templateDetails?.templateBrands?.length > 0
            ? templateDetails?.templateBrands?.[0]
            : null
          : null;
        let comBrand = global_brands?.competitor ? global_brands : null;
        isParentOfExplodedWidget = comBrand
          ? {
              numberOfCompetitor: comBrand?.competitorList?.length + 1,
            }
          : null;
      }
      if (
        sectionData?.data?.length === 1 ||
        sectionData?.data?.length ===
          isParentOfExplodedWidget?.numberOfCompetitor
      ) {
        dispatch(setDeleteTopic(Section, section_id));
      }
      if (sectionData?.data?.length !== 1 && footerValue.template) {
        dispatch(
          setDeleteWidget(
            Section,
            section_id,
            widget_id,
            widget_index,
            isParentOfExplodedWidget
          )
        );
      }
      callNotification("Widget deleted successfully", "success");

      setDeleteModalShow(value);
      //to clear id from opdata
      //high chart option data clear start
      let widget = {
        section_index: section_index ? section_index : 0,
        widget_index: widget_index,
      };
      let updateOpData = clearHighChartopData(widget, widget_id);
      dispatch(setOptionHighChart(updateOpData));
      //high chart option data clear end
      //dispatch(setOptionHighChart(null));
    } else if (widgetDelete === "no") {
      setDeleteModalShow(value);
    }
  };

  return (
    <>
      <div className="portlet__title d-flex align-items-center fontSize-16 font-weight500">
        <Tooltip title="Reorder widget" placement="top">
          <span
            className={`checklist ${checkboxInput && "d-none"} ${
              disableReodering ? "disabled" : ""
            }`}
            style={{ color: "#869dad" }}
            id={widget_index}
            onClick={(e) => checkboxEditMode("show", widget_index)}
          >
            {widget_index + 1}
          </span>
        </Tooltip>

        <div
          className={`align-items-center border border-radius-4 ${
            checkboxInput ? "border-blue" : "border-color"
          } ${checkboxInput ? "d-flex" : "d-none"}`}
          style={{ overflow: "hidden" }}
        >
          <Input
            className="checklist p-0 m-0 text-center text_regular border-0"
            type="number"
            value={checkboxInput?.order}
            min={1}
            style={{ color: "#869dad" }}
            onChange={(e) => checkboxEditMode(e, widget_index)}
            controls={false}
          />

          <Button
            className={`checklist active p-0 m-0 border-0 border-radius-0`}
            onClick={() => handleArrayOrder(widget_index)}
            style={{ height: "3rem", lineHeight: "3.2rem" }}
          >
            <i className="fa fa-check" />
          </Button>
        </div>
        {widget_id === "000-700-001" ? (
          <Tooltip title="This widget gets refreshed in every 1 minutes.">
            <span
              className="agent_widget_circle cursor-pointer ml-1 mr-2"
              //style={{ color: "#A020F0" }}
            />
          </Tooltip>
        ) : (
          ""
        )}
        <span
          className={`contenteditable_title cursor-pointer ${
            openPopover ? "show_editable_icon" : ""
          } `}
          style={{ display: "inline-block" }}
        >
          {popoverStatue?.status === "save" && popoverStatue?.title
            ? popoverStatue?.title
            : popoverStatue?.status === "cancel" &&
              popoverStatue?.title !== updateTitle
            ? popoverStatue?.title
              ? popoverStatue?.title
              : widget_name
            : widget_name}
          <Popover
            title={null}
            trigger="click"
            visible={openPopover}
            placement="bottom"
            onVisibleChange={handleOpenChange}
            content={
              <div className="p-15">
                <div className="floating-label-group">
                  <Input
                    maxLength={100}
                    className="mr-1 border border-color"
                    style={{ paddingRight: "5rem" }}
                    onChange={(e) => graphTitle(e.target.value, widget_id)}
                    value={
                      updateTitle === "" || updateTitle
                        ? updateTitle
                        : popoverStatue?.status === "cancel" &&
                          popoverStatue?.title !== updateTitle
                        ? popoverStatue?.title
                        : widget_name
                    }
                  />
                  <label className="portlet-label floating-label">
                    Widget Name
                  </label>
                  <span
                    style={{ bottom: "1rem", right: "0.5rem" }}
                    className="text-gray position-absolute font-size12"
                  >
                    {updateTitle === "" || updateTitle
                      ? updateTitle?.length
                      : popoverStatue?.status === "cancel" &&
                        popoverStatue?.title !== updateTitle
                      ? popoverStatue?.title?.length
                      : widget_name?.length}
                    /100
                  </span>
                </div>
                <div className="text-right w-100 mt-15">
                  <Button
                    className="btn_Clear"
                    onClick={() => handleClose("cancel")}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    className="ant-btn-primary_blue ml-15"
                    onClick={() => handleClose("save")}
                    disabled={
                      (popoverStatue?.title?.length || updateTitle?.length) ===
                        0 && true
                    }
                  >
                    Save
                  </Button>
                </div>
              </div>
            }
          >
            {/* <Input updateTitle
                      maxLength={100}
                      contenteditable={true}
                      className="contenteditable_title mr-1"
                      onChange={(e) => graphTitle(e.target.value, widget_id)}
                      value={
                        updateTitle === "" || updateTitle
                          ? updateTitle
                          : widget_name
                      }
                    /> */}
            <img
              src={EditIcon}
              alt="edit_icon"
              className={`edit-name ml-1 mr-1 ${
                openPopover || openPopoverWidgetDesc?.openStatus
                  ? "disable"
                  : ""
              }`}
            />
          </Popover>
        </span>
        {widgetData && !widgetData?.widget_description && (
          <WidgetDescription
            section_index={section_index}
            widget_index={widget_index}
            widget_id={widget_id}
            widgetData={widgetData}
            addDescription={true}
            openPopover={openPopover}
            setOpenPopoverWidgetDesc={setOpenPopoverWidgetDesc}
            openPopoverWidgetDesc={openPopoverWidgetDesc}
          />
        )}

        {/* {widgetDescRedioStatue === "icon" &&
          !openPopoverWidgetStatue?.openStatue &&
          !openPopoverWidgetStatue?.id === widget_id &&
          widgetDescriptions?.length > 0 && (
            <Tooltip placement="bottom" title="ttt">
              <i className="fa fa-info-circle cursor-pointer" />
            </Tooltip>
          )} */}
        {((Section &&
          Section?.[section_index ? section_index : 0]?.data?.[widget_index]
            ?.type === "predefined") ||
          (sections &&
            sections?.[section_index ? section_index : 0]?.widgets?.[
              widget_index
            ]?.type === "predefined") ||
          widgetData?.type === "predefined") &&
          widget_id !== "000-700-001" && (
            <Tooltip title="This is a predefined widget and does not support mention level filters">
              <span
                className="predefined_widget_circle cursor-pointer ml-1"
                //style={{ color: "#A020F0" }}
              />
            </Tooltip>
          )}
        <span
          className={`contenteditable_description cursor-pointer ${
            openPopoverWidgetDesc?.openStatus ? "show_editable_icon" : ""
          } `}
        >
          {widgetData?.widget_description &&
            widgetData?.widget_description_on_icon && (
              <Tooltip
                // title={widgetData?.widget_description}
                title={
                  <div
                    className="custom_scroll"
                    style={{
                      maxWidth: "270px",
                      maxHeight: "200px",
                      overflow: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <div className="mb-1">{widgetData?.widget_description}</div>
                  </div>
                }
                placement="bottom"
              >
                <i
                  className="fa fa-info-circle text-gray cursor-pointer ml-1"
                  //style={{ color: "#A020F0" }}
                />
              </Tooltip>
            )}
          {widgetData?.widget_description &&
            widgetData?.widget_description_on_icon &&
            (window.location.pathname?.split("/")?.[1] === "create-dashboard" ||
              window.location.pathname?.split("/")?.[1] ===
                "edit-dashboard") && (
              <WidgetDescription
                section_index={section_index}
                widget_index={widget_index}
                widget_id={widget_id}
                widgetData={widgetData}
                openPopover={openPopover}
                setOpenPopoverWidgetDesc={setOpenPopoverWidgetDesc}
                openPopoverWidgetDesc={openPopoverWidgetDesc}
              />
            )}
        </span>
      </div>
      {isDeleteModalShow && (
        <DeleteWidget
          isModalShow={isDeleteModalShow}
          handleChange={handleChange}
          modalText={modalText}
          sectionId={section_id}
        />
      )}
    </>
  );
};

export default React.memo(WidgetHeaderEditMode, isEqual);
